import { Component, OnInit, ViewChild } from '@angular/core';
import { Absence, AbsenceCurrentUser } from '../../absences.model';
import { NgForm } from '@angular/forms';
import { LoginRest } from '../../../login/login.rest';
import { DictionaryRest } from '../../../dictionaries/dictionary/dictionary.rest';
import { AbsencesRest } from '../../absences.rest';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { DateInputModel } from '../../../core/shared/date-input/date-input.model';
import { Permissions } from '../../../core/services/permissions/permissions.model';
import { NgxSelectOption, INgxSelectOption } from 'ngx-select-ex';
import { WorklogsRest } from '../../../worklogs/worklogs.rest';

@Component({
  selector: 'app-absence-header',
  templateUrl: './absence-header.component.html',
  styleUrls: ['./absence-header.component.scss']
})
export class AbsenceHeaderComponent implements OnInit {

  constructor(
    private rest: AbsencesRest,
    private dictionaryRest: DictionaryRest,
    private loginRest: LoginRest,
    private worklogsRest: WorklogsRest) { }

  public employeeRows: ObjectToSelect[];
  public absenceTypes: { id: number, value: string }[];
  public startDate: DateInputModel;
  public endDate: DateInputModel;

  public isNew: boolean;
  public absence: Absence;

  private afterViewInit = false;
  public isValid: boolean = true;
  public isEditable: Boolean = false;
  permissions: Permissions;
  currentUser: AbsenceCurrentUser;

  @ViewChild('absenceForm') absenceForm: NgForm;
  ngOnInit() {
    this.getAbsenceTypes();
  }

  public setModel(absence: Absence, isNew: boolean, permission: Permissions, currentUser: AbsenceCurrentUser) {
    this.permissions = permission;
    this.absence = absence;
    this.isNew = isNew;
    this.currentUser = currentUser;
    this.isEditable = (this.permissions.canEdit || this.permissions.canShow) && (currentUser.isSupervisor || absence.employeeId == currentUser.employeeId) && (absence.absenceStateInternalName == "Buffered" || isNew);
    this.initializeDate();
    this.getEmployees();

    if (isNew) {
      if (!this.absence.absenceTypeId) {
        this.absence.absenceTypeId = this.absenceTypes[0].id;
      }
      if (!this.absence.employeeId) {
        this.absence.employeeId = this.employeeRows[0].id;
      }
    }
    this.afterViewInit = true;
  }

  private initializeDate() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = !this.isEditable;
    this.startDate.isRequired = false;
    this.startDate.name = 'Nieobecnośc od';
    this.startDate.value = new Date(this.absence.startDate);
    this.startDate.value.setHours(0, 0, 0, 0);
    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.withTime = true;
    this.startDate.internalName = 'StartDate';

    this.endDate = new DateInputModel();
    this.endDate.isReadOnly = !this.isEditable;
    this.endDate.isRequired = false;
    this.endDate.name = 'Nieobecnośc do';
    this.endDate.value = new Date(this.absence.endDate);
    this.endDate.value.setHours(23, 59, 59, 0);
    this.endDate.valueStr = this.endDate.value.toDateString();
    this.endDate.withTime = true;
    this.endDate.internalName = 'EndDate';
  }

  private getAbsenceTypes() {
    this.dictionaryRest.getDictionaries(11).subscribe((dictionaries: any) => {
      this.absenceTypes = dictionaries;
    });
  }

  private getEmployees() {
    var action;
    if (this.permissions.hasAllWorklogsPermission) {
      action = this.worklogsRest.getUsersRows;
    }
    else {
      if (this.isEditable) {
        action = this.worklogsRest.getSubordinates;
      } else {
        action = this.worklogsRest.getUsersRows;
      }
    }
    action.call(this.rest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.employeeRows = result.sort((x, y) => x.name > y.name ? 1 : -1);
      }
    });
  }

  private onElementValidation(element: DateInputModel, isValid: boolean) {
    if (!element) {
      return;
    }

    if (element.internalName == 'StartDate') {
      this.absence.startDate = element.value;
      this.startDate.valueStr = this.startDate.value.toDateString();

      if (this.startDate.value > this.endDate.value) {
        this.endDate.value = new Date(element.value);
        this.absence.endDate = this.endDate.value;
        this.endDate.valueStr = this.endDate.value.toDateString();
      }
    }

    if (element.internalName == 'EndDate') {
      this.absence.endDate = element.value;
      this.endDate.valueStr = this.endDate.value.toDateString();
      if (element.value < this.startDate.value) {
        this.startDate.value = new Date(element.value);
        this.startDate.value.setHours(0, 0, 0, 0);
        this.absence.startDate = this.startDate.value;
      }
    }
  }

  private checkSaveCondition() {
    if (this.absence.employeeId && this.absence.employeeId == 0) {
      return false;
    }
    if (this.absence.startDate > this.absence.endDate) {
      return false;
    }
    return true;
  }

  public isInvalid() {
    if (this.checkSaveCondition()) {
      return this.absenceForm.invalid;
    }
    return true;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }
  private searchCallback2(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.value.toLowerCase().includes(search);
  }


}
